import { ReactNode } from "react";

import { StyledEngineProvider } from "@mui/material";
import { WebShopThemeProvider } from "./WebShopThemeProvider";
import { TanstackQueryProvider } from "./TanstackQueryProvider";

interface WebShopRootProviderProps {
    children: ReactNode;
}

export const WebShopRootProvider = ({ children }: WebShopRootProviderProps) => {
    return (
        <StyledEngineProvider injectFirst>
            <WebShopThemeProvider>
                <TanstackQueryProvider>
                    {children}
                </TanstackQueryProvider>
            </WebShopThemeProvider>
        </StyledEngineProvider>
    );
};
